





























































































































































































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import InputCodeAndTextField from '@/components/molecules/InputCodeAndTextField/InputCodeAndTextField.vue'
import { SystemCode } from '@/api'
import { systemCodeStore } from '@/utils/store-accessor'
import dayjs from '@/node_modules/dayjs'
import {
  BookMaxlength,
  MarkMaxlength,
  NdcMask,
  NdcMaxlength,
  SubMaxlength
} from '@/types'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'

export interface InterLibraryLoanCollectionEntryFormCollectionItem {
  collectionNo: {
    input: string
    errorMessage: string
  }
  holdingBranchCode: {
    input: string
    errorMessage: string
  }
  collectionType: {
    input: string
    errorMessage: string
  }
  handlingType: {
    input: string
    errorMessage: string
  }
  appendixCode: {
    input: string
    errorMessage: string
  }
  interlibraryLoanCode: {
    input: string
    errorMessage: string
  }
  requestAdDate: {
    input: string
    errorMessage: string
  }
  borrowingDate: {
    input: string
    errorMessage: string
  }
  borrowingDueDate: {
    input: string
    errorMessage: string
  }
  mark: {
    input: string
    errorMessage: string
  }
  ndc: {
    input: string
    errorMessage: string
  }
  book: {
    input: string
    errorMessage: string
  }
  sub: {
    input: string
    errorMessage: string
  }
  workMemo: {
    input: string
    code: string
    errorMessage: string
  }
  displayMemo: {
    input: string
    code: string
    errorMessage: string
  }
  localMemo: {
    input: string
    code: string
    errorMessage: string
  }
}

export const defaultInterLibraryLoanCollectionEntryFormCollectionItem = (): InterLibraryLoanCollectionEntryFormCollectionItem => ({
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  holdingBranchCode: {
    input: '',
    errorMessage: ''
  },
  collectionType: {
    input: '',
    errorMessage: ''
  },
  handlingType: {
    input: '',
    errorMessage: ''
  },
  appendixCode: {
    input: '',
    errorMessage: ''
  },
  interlibraryLoanCode: {
    input: '',
    errorMessage: ''
  },
  requestAdDate: {
    input: dayjs().format('YYYYMMDD'),
    errorMessage: ''
  },
  borrowingDate: {
    input: dayjs().format('YYYYMMDD'),
    errorMessage: ''
  },
  borrowingDueDate: {
    input: dayjs().format('YYYYMMDD'),
    errorMessage: ''
  },
  mark: {
    input: '',
    errorMessage: ''
  },
  ndc: {
    input: '',
    errorMessage: ''
  },
  book: {
    input: '',
    errorMessage: ''
  },
  sub: {
    input: '',
    errorMessage: ''
  },
  workMemo: {
    input: '',
    code: '',
    errorMessage: ''
  },
  displayMemo: {
    input: '',
    code: '',
    errorMessage: ''
  },
  localMemo: {
    input: '',
    code: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCollectionNo,
    InputCodeAndTextField,
    InputCode,
    InputDatePicker
  }
})
export default class InterLibraryLoanCollectionEntryFormCollection extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InterLibraryLoanCollectionEntryFormCollectionItem

  get exclusionCodesByWorkMemo(): string[] {
    return systemCodeStore.exclusionCodesByWorkMemo
  }

  get exclusionCodesByDisplayMemo(): string[] {
    return systemCodeStore.exclusionCodesByDisplayMemo
  }

  get exclusionCodesByLocalMemo(): string[] {
    return systemCodeStore.exclusionCodesByLocalMemo
  }

  get markMaxlength(): string {
    return MarkMaxlength
  }

  get ndcMask(): string {
    return NdcMask
  }

  get ndcMaxlength(): string {
    return NdcMaxlength
  }

  get bookMaxlength(): string {
    return BookMaxlength
  }

  get subMaxlength(): string {
    return SubMaxlength
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onInputSystemCode(item: SystemCode | SystemCode[] | null, obj: any): void {
    if (Array.isArray(item) || item === null) return
    obj.input = item.shortName
  }
}
